<template>
  <div>
    <list-header title="My Package" />
    <div v-if="sectionsPurchase.length > 0">
      <div class="style-content mt-3">
        <nav-tab
          :tabs="sectionsPurchase"
          :selected-tab="selectedTabID"
          @selected-tab="selectedTabID = $event"
          cssClass="scss-fixed-tabs"
        >
          <div v-for="redemption in purchaseItems" :key="redemption.sectionID">
            <tab :isSelected="selectedTabID === redemption.sectionID">
              <fieldset id="group1">
                <div
                  v-if="
                    redemption.sectionName === 'Services' &&
                    redemption.items.length > 0
                  "
                >
                  <div v-for="item in redemption.items" :key="`${ item.productId }-${ item.ticketlineId }`">
                    <purchase-item :purchaseItem="item" :disableButton="!item.product.service.showForOnlineAppointment" />
                  </div>
                </div>
                <div
                  v-else-if="
                    redemption.sectionName === 'Coupons' &&
                    redemption.items.length > 0
                  "
                >
                  <div v-for="item in redemption.items" :key="`${ item.productId }-${ item.ticketlineId }`">
                    <credit-item :purchaseItem="item" />
                  </div>
                </div>
                <div
                  v-else-if="
                    redemption.sectionName === 'Products' &&
                    redemption.items.length > 0
                  "
                >
                  <div v-for="item in redemption.items" :key="`${ item.productId }-${ item.ticketlineId }`">
                    <purchase-item :purchaseItem="item" :disableButton="true" />
                  </div>
                </div>
                <div v-else>
                  <item-not-found message="No items found." />
                </div>
              </fieldset>
            </tab>
          </div>
        </nav-tab>
      </div>
    </div>

    <!-- Services not found -->
    <div v-else>
      <item-not-found message="No items found." />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import { ProductType } from "@/common/constant/ProductType";
import NavTab from "@/components/tab/NavTab";
import Tab from "@/components/tab/Tab";
import ItemNotFound from "@/components/ItemNotFound";
import PurchaseItem from "@/views/MyAccount/MyRedemption/components/PurchaseItem";
import CreditItem from "@/views/MyAccount/MyRedemption/components/CreditItem";
import ListHeader from "@/components/ListHeader";

export default {
  name: "MyRedemption",
  components: {
    ListHeader,
    NavTab,
    Tab,
    ItemNotFound,
    PurchaseItem,
    CreditItem,
  },
  data() {
    return {
      selectedTabID: null,
      purchaseItems: [
        {
          sectionID: 1,
          sectionName: "Services",
          items: [],
        },
        {
          sectionID: 2,
          sectionName: "Products",
          items: [],
        },
        {
          sectionID: 3,
          sectionName: "Coupons",
          items: [],
        },
      ],
    };
  },
  computed: {
    sectionsPurchase() {
      return [
        { id: 1, name: `Services (${this.purchaseItems[0].items.length})` },
        { id: 2, name: `Products (${this.purchaseItems[1].items.length})` },
        {
          id: 3,
          name: `Coupons (${this.purchaseItems[2].items.length})`,
        },
      ];
    },

    ...mapGetters(["redemptions"]),
  },
  methods: {
    ...mapActions(["getRedemptionList"]),
  },
  created() {
    this.getRedemptionList().then(() => {
      this.redemptions.map((redemption) => {
        const type = redemption.product.type;
        if (type === ProductType.SERVICE) {
          this.purchaseItems[0].items.push(redemption);
        } else if (type === ProductType.RETAIL_PRODUCT) {
          this.purchaseItems[1].items.push(redemption);
        } else if (type === ProductType.COUPON) {
          this.purchaseItems[2].items.push(redemption);
        }
      });
    });
  },
};
</script>

<style lang="scss" scoped>
.style-checkbox {
  font-size: 20px;
}

.style-action-container {
  margin: 0 auto 0 auto;
  padding-top: 5px;
  max-width: 510px;
  border: 1px solid $border-light-grey;
  background-color: white;
  z-index: 5;
}

.style-content {
  width: 90%;
  margin: 0 auto 0 auto;
  margin-bottom: 70px;
}
</style>
